import { NgModule } from '@angular/core';

// xplat
import { Moduurnv2CoreModule } from '@moduurnv2/web';

@NgModule({
  imports: [Moduurnv2CoreModule],
})
export class CoreModule {}
